import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { Observable, defer } from "rxjs";
import { DatabaseService } from "src/app/database/database.service";
import AdjuntosClass from "src/app/model/api/datos/adjuntosClass";
import FotosClass from "src/app/model/api/datos/fotosClass";
import ProgramacionClass from "src/app/model/api/datos/programacionClass";
import InspeccionClass from "src/app/model/api/inspecciones/inspeccionClass";
import InspeccionYProgramacion from "src/app/model/api/inspecciones/inspeccionYProgramacion";
import { AlertService } from "src/app/services/alert.service";
import { LoaderService } from "src/app/services/loader.service";

export const OrdenesTrabajoDetalleResolver: ResolveFn<InspeccionYProgramacion> =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<InspeccionYProgramacion> => {
    
    const loader = inject(LoaderService)
    const alertService = inject(AlertService)
    const database = inject(DatabaseService)

    return defer(async () => {

        await loader.show('Cargando...')
        try {

            let id = parseInt(route.paramMap.get('id'), 10)

            let ordenTrabajo: InspeccionClass
            if (id == 0) {
                ordenTrabajo = new InspeccionClass
                ordenTrabajo.Id = 0
            } else {
                ordenTrabajo = await database.OrdenesTrabajo.getByLocalId(id)
            }

            // Cargamos, si existe, la programación específica para este AreaId.
            let programacion: ProgramacionClass = null
            if (ordenTrabajo.AreaId != null) {
                programacion = await database.Programaciones.getByAreaId(ordenTrabajo.AreaId)
            }

            // Cargamos las fotos, en el caso de que existan.
            let fotos: FotosClass[] = await database.Fotos.getByOrdenLocalId(ordenTrabajo.LocalId) || []
            
            // Cargamos los adjuntos, en el caso de que existan.
            let adjuntos: AdjuntosClass[] = await database.Adjuntos.getByOrdenLocalId(ordenTrabajo.LocalId) || []

            await loader.hideAll()
            let result = new InspeccionYProgramacion()
            result.Inspeccion = ordenTrabajo
            result.Programacion = programacion
            result.Fotos = fotos
            result.Adjuntos = adjuntos

            return result

        } catch (ex) {
            await loader.hideAll()
            alertService.showMessage(ex?.message || 'No se ha podido cargar la orden de trabajo.', 'Ingein')
            throw ex
        }

    })

}